import { WorklogItemResponse } from '../types/dto/worklogs-summary.dto';
import { TimeTrack } from '../types/time-tracking';
import { mapWorklogIntegrationStatus } from './worklog-integration.mapper';

/** Maps a single worklog search-result item from its wire shape to the domain `TimeTrack`. */
export const mapTimeTrackFromResponse = (response: WorklogItemResponse): TimeTrack => ({
  id: response.id,
  date: response.date,
  trackedMinutes: response.trackedMinutes,
  description: response.description ?? '',
  isRunning: false,
  isApproved: response.isApproved,
  integrations: mapWorklogIntegrationStatus(response.integrations),
});

export const mapTimeTracksFromResponse = (responses: WorklogItemResponse[]): TimeTrack[] =>
  responses.map(mapTimeTrackFromResponse);
